import React, {useCallback, useEffect, useMemo, useState} from 'react';
import Currency from "../Utils/Number/Currency";
import DateFormated from "../Utils/Date/Date";
import {useTranslation} from "react-i18next";
import Aux from "../../hoc/Auxiliary";
import CheckedTable from "./CheckedTable";
import Export from "../Utils/XLS/Export";
import Sorter from "../UI/Toolbar/Sorter";
import {fireGTMDownloadFileEvent} from "../Utils/GTM/GTMHelper";

const ByInvoice = (props) => {
    const {t, i18n} = useTranslation();
    const [checked, setChecked] = useState([]);
    const [sortTableField, setSortTableField] = useState('dueDate');
    const [sortTableDirection, setSortTableDirection] = useState('ASC');
    const [isSelectAll, setIsSelectAll] = useState(false);
    let descAccessor = ((i18n.language === 'fr') ? 'descriptionFr' : 'descriptionEn');

    useEffect(
        () =>
            isSelectAll
                ? setChecked(props.data.map((invoice) => invoice.invoiceNumber))
                : setChecked([]),
        [isSelectAll]
    );

    useEffect(() => {
        if(props.locationState.state && props.locationState.state.selection ){
            setChecked([props.locationState.state.selection[0]]);
            props.locationState.state = undefined; // One timer
        }
    },[]);

    useEffect(
        () =>{
            if(checked.length !== 0){
                let total = 0;
                let theSelection = props.data.filter((thisChecked) => checked.includes(thisChecked.invoiceNumber));
                let arrayOfElements = [];
                theSelection.map((item)=> {
                   total += item.balanceAmount.value;
                    arrayOfElements.push(item);
                });
                let array = {
                    total : total,
                    selection : arrayOfElements
                }
                props.handleByInvoice(array);
            }else{
                props.handleByInvoice({ total : 0 });
            }
        },
        [checked]
    );

    const columns = useMemo(
        () => [
            {
                Header: (
                    <div className="form-check flex flex-row justify-content-end align-items-end">
                        <input
                            type="checkbox"
                            id="select_all"
                            className="form-check-input"
                            value={isSelectAll}
                            onChange={(v) => setIsSelectAll(v.target.checked)}
                        ></input>
                    </div>
                ),
                accessor: "checkBox",
                disableSortBy: true,
                Cell: (props) => {
                    return (
                        <div className="form-check flex flex-row justify-content-end">
                            <input
                                type="checkbox"
                                value={props.row.original.invoiceNumber}
                                className="form-check-input"
                                onChange={(v) => {
                                    handleCheck(
                                        v.target.checked,
                                        v.target.value
                                    );
                                }}
                                checked={!!checked.includes(props.row.original.invoiceNumber)}
                            ></input>
                        </div>
                    );
                }
            },
            {
                Header: t("docs.invoices.table.headers.accountbilled"),
                accessor: "subAccountName",
                id: 'subAccountName',

                Cell: (props) => {
                    return (
                        <Aux>
                            <strong>
                                {props.value != "" ? props.value : props.row.original.accountName} - {props.row.original.subAccountCode}
                            </strong>
                            <br />
                            <small>
                                {Object.values(props.row.original.subAccountAddress)
                                    .filter((el) => {
                                        return el != null && el !== "";
                                    })
                                    .join(", ")}
                            </small>
                        </Aux>
                    );
                },
            },{
                Header: t('docs.invoices.table.headers.invoice_no'),
                accessor: 'invoiceNumber',
                id: 'invoiceNumber',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },{
                id: "statementDate",
                Header: t("docs.invoices.table.headers.statementdate"),
                accessor: "statementDate",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <DateFormated date={props.value} withTime={false} />
                        );
                    } else {
                        return "";
                    }
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1) return 1;
                    else if (a1 > b1) return -1;
                    else return 0;
                },
            },{
                id: "dueDate",
                Header: t("docs.invoices.table.headers.payment_due_date"),
                accessor: "dueDate",
                sort: "desc",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <DateFormated date={props.value} withTime={false} />
                        );
                    } else {
                        return "";
                    }
                },
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if (a1 < b1) return 1;
                    else if (a1 > b1) return -1;
                    else return 0;
                },
            },{
                Header: t('docs.invoices.table.headers.status'),
                accessor: 'transactionStatus.'+descAccessor,
                id:'transactionStatus',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },{
                Header: t('docs.invoices.table.headers.po'),
                id: 'purchaseOrderNumber',
                accessor: 'purchaseOrderNumber',
                Cell: (props) => {
                    return (props.value) ? props.value : '';
                },
            },{
                Header: t('dashboard.subaccounts.table.header.balancedue'),
                id: 'balanceAmount',
                accessor: 'balanceAmount.value',
                Cell: (props) => {
                    return (props.value) ? <Currency value={props.value} /> : ''; },
            },{
                Header: () => null,
                id: "file", // 'id' is required
                accessor: "documentPath",
                Cell: (props) => {
                    if (props.value) {
                        return (
                            <a
                                href={`/rest/v1/communications/download?filename=${encodeURI(
                                    props.value
                                )}`}
                                target="_blank"
                                className="link link--red link--upper link--accent link--fs-14"
                            >
                                <i className="far fa-file-download fa-2x"></i>
                            </a>
                        );
                    } else {
                        return "";
                    }
                }
            },
        ],
        [t, i18n,props.data,checked]
    );

    const handleSort = (sortBy) => {
        if (sortBy.length > 0) {
            const isDESC = sortTableDirection === 'DESC'
            if (sortTableField !== sortBy[0].id || isDESC !== sortBy[0].desc) {
                setSortTableDirection(sortBy[0].desc ? 'DESC' : 'ASC');
                setSortTableField(sortBy[0].id)
            }
        }
    }

    const handleCheck = (isChecked, value) => {
        if (isChecked && !checked.includes(value)) {
            setChecked((checked) => [
                ...checked.filter((thisChecked) => thisChecked !== value),
                value,
            ]);
        } else {
            setChecked((checked) =>
                checked.filter((thisChecked) => thisChecked !== value)
            );
        }
    };

    const setSorterCallback = (columnId, direction) => {
        setSortTableField(columnId)
        setSortTableDirection(direction)
    }
    const setSortByCallback = useMemo(() =>
            [{desc:sortTableDirection==='DESC', id:sortTableField}]
        , [sortTableDirection, sortTableField])


    const doXLSExport = useCallback((fileType) => {
        const checkedInvoices = props.data
            .filter((item) => checked.includes(item.invoiceNumber.toString()))
            .map((item) => ({
                [t("export.invoices.subAccountCode")]: item.subAccountCode,
                [t("export.invoices.transactionDateTime")]:
                    new Date(item.transactionDateTime.split('T')[0]),
                [t("export.invoices.invoiceNumber")]: item.invoiceNumber,
                [t("export.invoices.dueDate")]: new Date(item.dueDate.split('T')[0]),
                [t("export.invoices.netAmount")]: item.netAmount?.value || '',
                [t("export.invoices.balanceAmount")]: item.balanceAmount?.value || '',
                [t("export.invoices.poNumber")]: item.purchaseOrderNumber,
            }));
        Export(checkedInvoices, "harnois_export", [
            t("export.invoices.netAmount"),
            t("export.invoices.balanceAmount"),
        ], fileType);
		fireGTMDownloadFileEvent('facture',fileType+' - Sommaire');
    }, [checked, props.data]);
    /*
    const doXLSDetailExport = useCallback(async (fileType) => {
        setLoading(true);
        const transactions = await getInvoiceLines({
            subAccountCode,
            startDate, //: `${startDate.toISOString().split("T")[0]}T00:00:00.000Z`,
            endDate, //: `${endDate.toISOString().split("T")[0]}T23:59:59.999Z`,
        });

        const mappedTransactions =
            transactions &&
            transactions.data &&
            transactions.data
                .filter((transaction) =>
                    checked.includes(transaction.invoiceNumber.toString())
                )
                .map((transaction) => {
                    let datas = {
                        [t("export.invoiceLines.subAccountCode")]:
                        transaction.subAccountCode,
                        [t("export.invoiceLines.invoiceNumber")]:
                        transaction.invoiceNumber,
                        [t("export.invoiceLines.transactionDateTime")]:
                            new Date(transaction.transactionDateTime+'Z'),
                        [t("export.invoiceLines.productCode")]:
                        transaction.productCode,
                        [t("export.invoiceLines.productName")]:
                            transaction.productName.values[
                                transaction.productName.keys.indexOf(
                                    i18n.language
                                )
                                ],
                        [t("export.invoiceLines.quantity")]: Number(
                            Number(transaction.quantity.value).toFixed(3)
                        ),
                        [t("export.invoiceLines.priceAfterExciseTaxes")]:
                        transaction.priceAfterExciseTaxes.value,
                        [t("export.invoiceLines.amountAfterExciseTaxes")]:
                        transaction.amountAfterExciseTaxes.value,
                        [t("export.invoiceLines.gstAmount")]:
                        transaction.gstAmount.value,
                        [t("export.invoiceLines.pstAmount")]:
                        transaction.pstAmount.value,
                        [t("export.invoiceLines.netAmount")]:
                        transaction.netAmount.value,
                        [t("export.invoiceLines.date")]:
                            transaction.transactionDateTime
                                .split("T")[0],
                        [t("export.invoiceLines.time")]:
                            transaction.transactionDateTime.split("T")[1],
                        [t("export.invoiceLines.carrierDeliveryNumber")]:
                        transaction.carrierDeliveryNumber,
                        [t("export.invoiceLines.truckName")]:
                        transaction.truckName,
                        [t("export.invoiceLines.poNumber")]:
                        transaction.purchaseOrderNumber,
                    };

                    return datas;
                });
        Export(mappedTransactions, "harnois_export", [
            t("export.invoiceLines.netAmount"),
        ], fileType);
        setLoading(false);
    }, [props.startDate, props.endDate, checked]); */

    let sorterValues = [
        {
            label: t("docs.invoices.table.headers.account"),
            id: 'subAccountName',
            value: 'subAccountName',
            type: 'string'
        },{
            label: t("docs.invoices.table.headers.invoice_no"),
            id: 'invoiceNumber',
            value: 'invoiceNumber',
            type: 'int'
        },
        {
            label: t("docs.invoices.table.headers.statementdate"),
            id: 'statementDate',
            value: '-statementDate',
            type: 'date'
        },
        {
            label: t("docs.invoices.table.headers.due_date"),
            id: 'dueDate',
            value: '-dueDate',
            type: 'date'
        },{
            label: t("docs.invoices.table.headers.status"),
            id: 'transactionStatus',
            value: i18n.language === 'fr' ? 'transactionStatus.descriptionFr': 'transactionStatus.descriptionEn',
            type: 'string'
        },{
            label: t("docs.invoices.table.headers.po"),
            id: 'purchaseOrderNumber',
            value: 'purchaseOrderNumber',
            type: 'string'
        },{
            label: t("docs.invoices.table.headers.balance"),
            id: 'balanceAmount',
            value: 'balanceAmount.value',
            type: 'float'
        }
    ];

    return (
        <React.Fragment>

            <CheckedTable
                columns={columns}
                data={props.data}
                doXLSExport={doXLSExport}
                doXLSDetailExport={null}
                checked={checked}
                hideExport={false}
                onSort={handleSort}
                setSortByCallback={setSortByCallback}
                initialStateField={sortTableField}
                initialStateDirection={sortTableDirection}
                children={<Sorter
                    sortOptions={sorterValues}
                    items={props.data}
                    getSortedItems={props.data}
                    setSortByCallback={setSorterCallback}
                    sortDirection={sortTableDirection}
                    sortField={sortTableField}
                    currentDisplayMode='list'
                />}
            />
        </React.Fragment>
    )
};

export default ByInvoice;
